module.exports = __webpack_public_path__ + "media/images/badge-edge-878b771d0f1bcf48813c2fdce1a368ac.svg";